export default "__VITE_ASSET__Cp9oB3k4__"